module.exports = __webpack_public_path__ + "static/img/new_logo.eb88592b.png";